import type { NavigateFunction } from 'react-router-dom'

/**
 * Opens a conversation path in a new tab, falling back to same-tab navigation if the tab is
 * blocked (common on mobile browsers when window.open is called after an awaited network call,
 * since the user-gesture context needed to bypass the popup blocker no longer applies).
 *
 * No 'noopener' feature: with it, window.open returns null even when the tab opens (per spec),
 * which would make blocked-popup detection impossible. Severing opener by hand keeps the same
 * isolation and leaves null meaning exactly "blocked".
 */
export function openConversationTab(conversationPath: string, navigate: NavigateFunction): void {
  const win = window.open(conversationPath, '_blank')
  if (win) {
    win.opener = null
  } else {
    // The conversation already exists at this point, so navigating in place beats a
    // success-looking no-op that strands it empty and unseen.
    navigate(conversationPath)
  }
}
